import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { useIsMobile, useIsTablet } from '../../hooks/useMediaQuery';
export function MainLayout() {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [tabletSidebarOpen, setTabletSidebarOpen] = useState(false);
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();
  // Scroll direction tracking for tablet TopBar hide/show
  const [topBarVisible, setTopBarVisible] = useState(true);
  const lastScrollY = useRef(0);
  const mainRef = useRef<HTMLElement>(null);
  const handleScroll = useCallback(() => {
    if (!mainRef.current) return;
    const currentScrollY = mainRef.current.scrollTop;
    const delta = currentScrollY - lastScrollY.current;
    if (delta > 8) {
      // Scrolling down — hide topbar
      setTopBarVisible(false);
    } else if (delta < -8) {
      // Scrolling up — show topbar
      setTopBarVisible(true);
    }
    lastScrollY.current = currentScrollY;
  }, []);
  useEffect(() => {
    const mainEl = mainRef.current;
    if (!mainEl || !isTablet) {
      setTopBarVisible(true);
      return;
    }
    mainEl.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => mainEl.removeEventListener('scroll', handleScroll);
  }, [isTablet, handleScroll]);
  // On tablet, sidebar is overlay — content always starts at ml-0
  // On desktop, sidebar is fixed — content needs margin
  const contentMarginClass = isMobile ? 'ml-0' : isTablet ? 'ml-0' : 'ml-[260px]';
  return <div className="min-h-screen bg-clinical-gray flex" data-id="element-57">
      <Sidebar isMobileOpen={mobileSidebarOpen} isTabletOpen={tabletSidebarOpen} onCloseMobile={() => setMobileSidebarOpen(false)} onToggleTablet={() => setTabletSidebarOpen(prev => !prev)} onCloseTablet={() => setTabletSidebarOpen(false)} data-id="element-58" />

      <div className={`
          flex-1 flex flex-col transition-all duration-300 ease-in-out w-full min-w-0 overflow-x-hidden
          ${contentMarginClass}
        `} data-id="element-59">
        <TopBar onOpenMobileSidebar={() => setMobileSidebarOpen(true)} onToggleTabletSidebar={() => setTabletSidebarOpen(prev => !prev)} isTabletSidebarOpen={tabletSidebarOpen} topBarVisible={topBarVisible} data-id="element-60" />
        <main ref={mainRef} className={`flex-1 overflow-y-auto overflow-x-hidden transition-[margin-top] duration-300 ease-in-out ${isTablet ? topBarVisible ? 'mt-16' : 'mt-0' : 'mt-16'}`} style={isTablet ? {
        height: '100vh'
      } : undefined} data-id="element-61">
          <div className="max-w-[1600px] w-full mx-auto px-4 md:px-6 lg:px-8 py-4 md:py-8 box-border min-w-0" data-id="element-62">
            <Outlet data-id="element-63" />
          </div>
        </main>
      </div>
    </div>;
}